export interface ReviewPart {
  partNumber: string;
  partName: string;
  quantity: number;
  dealership: string | null;
  city: string | null;
}

export interface ChassisRevision {
  revIndex: number;
  label: string;
  km: number | null;
  dnSg?: string;
  repairDate?: string;
  parts?: ReviewPart[];
}

export interface ChassisData {
  chassis: string;
  model: string;
  modelCode: string;
  maintenanceContract: string | null;
  contractStatus: string | null;
  lastRevisionDate: string | null;
  revisions: ChassisRevision[];
}

export const CHASSIS_REVIEW_DATA: ChassisData[] = [
  {
    chassis: "9539J8TH0TR201543",
    model: "28.480 6X2 HD 5.000 480C",
    modelCode: "TH5PJG",
    maintenanceContract: "X7641G",
    contractStatus: "A",
    lastRevisionDate: "27/03/2026",
    revisions: [
      {
        revIndex: 2,
        label: "1ª REV",
        km: 24284,
            dnSg: "1972 - 7901",
            repairDate: "25/11/2025",
            parts: [
                { partNumber: "2V3/127177/B", partName: "ELEM FILTR", quantity: 1, dealership: null, city: null },
                { partNumber: "2V5/201512/J", partName: "FILTR COMB", quantity: 1, dealership: null, city: null },
                { partNumber: "G/052739/Q9", partName: "GRAXA", quantity: 1, dealership: null, city: null },
            ],
        },
        {
            revIndex: 3,
            label: "2ª REV",
            km: 49617,
            dnSg: "4972 - 40717 / 4972 - 40718",
        repairDate: "27/03/2026",
        parts: [
          { partNumber: "07W/115561/E", partName: "ELEM FILTR",  quantity: 1,  dealership: "Mondial Veículos Ltda.", city: "Lajeado" },
          { partNumber: "2V3/127177/B", partName: "ELEM FILTR",  quantity: 1,  dealership: "Mondial Veículos Ltda.", city: "Lajeado" },
          { partNumber: "2V3/129620/D", partName: "ELEMENTO",    quantity: 1,  dealership: "Mondial Veículos Ltda.", city: "Lajeado" },
          { partNumber: "2V3/129620/E", partName: "ELEMENTO",    quantity: 1,  dealership: "Mondial Veículos Ltda.", city: "Lajeado" },
          { partNumber: "2V5/201512/J", partName: "FILTR COMB",  quantity: 1,  dealership: "Mondial Veículos Ltda.", city: "Lajeado" },
          { partNumber: "G/052168/Q9",  partName: "OLEO MOTOR",  quantity: 42, dealership: "Mondial Veículos Ltda.", city: "Lajeado" },
          { partNumber: "G/052739/Q9",  partName: "GRAXA",        quantity: 1,  dealership: "Mondial Veículos Ltda.", city: "Lajeado" },
          { partNumber: "G/411381/Q9",  partName: "ADITIVO",      quantity: 2,  dealership: "Mondial Veículos Ltda.", city: "Lajeado" },
          { partNumber: "JZV/820367/",  partName: "ELEM FILTR",  quantity: 1,  dealership: "Mondial Veículos Ltda.", city: "Lajeado" },
          { partNumber: "N/020905/7",   partName: "ABRACADEIR",  quantity: 10, dealership: "Mondial Veículos Ltda.", city: "Lajeado" },
          { partNumber: "WHT/007791/H", partName: "ANEL",         quantity: 1,  dealership: "Mondial Veículos Ltda.", city: "Lajeado" },
            { partNumber: "2V3/957039/A", partName: "TACOGRAFO", quantity: 0, dealership: "Mondial Veículos Ltda.", city: "Lajeado" },
        ],
      },
      {
        revIndex: 4,
        label: "3ª REV",
        km: null,
        parts: [],
      },
    ],
  },
  {
    chassis: "9539J8TH2TR201544",
    model: "28.480 6X2 HD 5.000 480C",
    modelCode: "TH5PJG",
    maintenanceContract: "X7641G",
    contractStatus: "A",
    lastRevisionDate: "12/02/2026",
    revisions: [
      {
        revIndex: 2,
        label: "1ª REV",
        km: 22520,
        dnSg: "4972 - 36778",
        repairDate: "22/10/2025",
        parts: [
          { partNumber: "2V3/127177/B", partName: "ELEM FILTR",  quantity: 1,  dealership: "Mondial Veículos Ltda.", city: "Lajeado" },
          { partNumber: "2V5/201512/J", partName: "FILTR COMB",  quantity: 1,  dealership: "Mondial Veículos Ltda.", city: "Lajeado" },
          { partNumber: "G/052739/Q9",  partName: "GRAXA",        quantity: 1,  dealership: "Mondial Veículos Ltda.", city: "Lajeado" },
          { partNumber: "G/052823/Q9",  partName: "LUBRIFICAN",   quantity: 4,  dealership: "Mondial Veículos Ltda.", city: "Lajeado" },
          { partNumber: "N/020905/7",   partName: "ABRACADEIR",   quantity: 6,  dealership: "Mondial Veículos Ltda.", city: "Lajeado" },
        ],
      },
      {
        revIndex: 3,
        label: "2ª REV",
        km: 48370,
        dnSg: "4972 - 39633",
        repairDate: "12/02/2026",
        parts: [
          { partNumber: "07W/115561/E", partName: "ELEM FILTR",  quantity: 1,  dealership: "Mondial Veículos Ltda.", city: "Lajeado" },
          { partNumber: "2V3/127177/B", partName: "ELEM FILTR",  quantity: 1,  dealership: "Mondial Veículos Ltda.", city: "Lajeado" },
          { partNumber: "2V3/129620/D", partName: "ELEMENTO",    quantity: 1,  dealership: "Mondial Veículos Ltda.", city: "Lajeado" },
          { partNumber: "2V3/129620/E", partName: "ELEMENTO",    quantity: 1,  dealership: "Mondial Veículos Ltda.", city: "Lajeado" },
          { partNumber: "2V5/201512/J", partName: "FILTR COMB",  quantity: 1,  dealership: "Mondial Veículos Ltda.", city: "Lajeado" },
          { partNumber: "G/052168/Q9",  partName: "OLEO MOTOR",  quantity: 42, dealership: "Mondial Veículos Ltda.", city: "Lajeado" },
          { partNumber: "G/052739/Q9",  partName: "GRAXA",        quantity: 1,  dealership: "Mondial Veículos Ltda.", city: "Lajeado" },
          { partNumber: "JZV/820367/",  partName: "ELEM FILTR",  quantity: 1,  dealership: "Mondial Veículos Ltda.", city: "Lajeado" },
          { partNumber: "WHT/007791/H", partName: "ANEL",         quantity: 1,  dealership: "Mondial Veículos Ltda.", city: "Lajeado" },
        ],
      },
      { revIndex: 4, label: "3ª REV", km: null, parts: [] },
    ],
  },
  {
    chassis: "9539J8TH3TR201536",
    model: "28.480 6X2 HD 5.000 480C",
    modelCode: "TH5PJG",
    maintenanceContract: "X7641G",
    contractStatus: "A",
    lastRevisionDate: "06/04/2026",
    revisions: [
      {
        revIndex: 2,
        label: "1ª REV",
        km: 25637,
        dnSg: "4778 - 51112",
        repairDate: "03/12/2025",
        parts: [
          { partNumber: "2V3/127177/B", partName: "ELEM FILTR",  quantity: 1, dealership: "Servopa Caminhões Ltda", city: "Curitiba" },
          { partNumber: "2V5/201512/J", partName: "FILTR COMB",  quantity: 1, dealership: "Servopa Caminhões Ltda", city: "Curitiba" },
          { partNumber: "G/052739/Q9",  partName: "GRAXA",        quantity: 1, dealership: "Servopa Caminhões Ltda", city: "Curitiba" },
        ],
      },
      {
        revIndex: 3,
        label: "2ª REV",
        km: 49433,
        dnSg: "4884 - 57590",
        repairDate: "03/02/2026",
        parts: [
          { partNumber: "07W/115561/E", partName: "ELEM FILTR",  quantity: 1,  dealership: "Transvel - Transportes E Veiculos Ltda", city: "Lobato" },
          { partNumber: "2V3/127177/B", partName: "ELEM FILTR",  quantity: 1,  dealership: "Transvel - Transportes E Veiculos Ltda", city: "Lobato" },
          { partNumber: "2V3/129620/D", partName: "ELEMENTO",    quantity: 1,  dealership: "Transvel - Transportes E Veiculos Ltda", city: "Lobato" },
          { partNumber: "2V3/129620/E", partName: "ELEMENTO",    quantity: 1,  dealership: "Transvel - Transportes E Veiculos Ltda", city: "Lobato" },
          { partNumber: "2V5/201512/J", partName: "FILTR COMB",  quantity: 1,  dealership: "Transvel - Transportes E Veiculos Ltda", city: "Lobato" },
          { partNumber: "G/052168/Q9",  partName: "OLEO MOTOR",  quantity: 42, dealership: "Transvel - Transportes E Veiculos Ltda", city: "Lobato" },
          { partNumber: "G/052739/Q9",  partName: "GRAXA",        quantity: 1,  dealership: "Transvel - Transportes E Veiculos Ltda", city: "Lobato" },
          { partNumber: "WHT/007791/H", partName: "ANEL",         quantity: 1,  dealership: "Transvel - Transportes E Veiculos Ltda", city: "Lobato" },
        ],
      },
      {
        revIndex: 4,
        label: "3ª REV",
        km: 74754,
        dnSg: "4883 - 65700 / 4883 - 65715",
        repairDate: "06/04/2026",
        parts: [
          { partNumber: "2V3/127177/B", partName: "ELEM FILTR",  quantity: 1, dealership: "Transvel - Transportes E Veiculos Ltda", city: "Cascavel" },
          { partNumber: "2V5/201512/J", partName: "FILTR COMB",  quantity: 1, dealership: "Transvel - Transportes E Veiculos Ltda", city: "Cascavel" },
          { partNumber: "G/052739/Q9",  partName: "GRAXA",        quantity: 1, dealership: "Transvel - Transportes E Veiculos Ltda", city: "Cascavel" },
          { partNumber: "2S2/957039/A", partName: "TACOGRAFO",   quantity: 0, dealership: "Transvel - Transportes E Veiculos Ltda", city: "Cascavel" },
        ],
      },
    ],
  },
  {
    chassis: "9539J8TH4TR201545",
    model: "28.480 6X2 HD 5.000 480C",
    modelCode: "TH5PJG",
    maintenanceContract: "X7641G",
    contractStatus: "A",
    lastRevisionDate: "23/01/2026",
    revisions: [
      {
        revIndex: 2,
        label: "1ª REV",
        km: 23050,
        dnSg: "1915 - 46704",
        repairDate: "28/10/2025",
        parts: [
          { partNumber: "2V3/127177/",  partName: "ELEM FILTR",  quantity: 1, dealership: "Maggi Caminhões Ltda.", city: null },
          { partNumber: "2V5/201512/J", partName: "FILTR COMB",  quantity: 1, dealership: "Maggi Caminhões Ltda.", city: null },
          { partNumber: "G/052739/Q9",  partName: "GRAXA",        quantity: 1, dealership: "Maggi Caminhões Ltda.", city: null },
        ],
      },
      {
        revIndex: 3,
        label: "2ª REV",
        km: 48189,
        dnSg: "4761 - 3967",
        repairDate: "23/01/2026",
        parts: [
          { partNumber: "07W/115561/E", partName: "ELEM FILTR",  quantity: 1,  dealership: "Original Veiculos Ltda", city: "Caxias Do Sul" },
          { partNumber: "2V3/127177/B", partName: "ELEM FILTR",  quantity: 1,  dealership: "Original Veiculos Ltda", city: "Caxias Do Sul" },
          { partNumber: "2V3/129620/D", partName: "ELEMENTO",    quantity: 1,  dealership: "Original Veiculos Ltda", city: "Caxias Do Sul" },
          { partNumber: "2V3/129620/E", partName: "ELEMENTO",    quantity: 1,  dealership: "Original Veiculos Ltda", city: "Caxias Do Sul" },
          { partNumber: "2V5/201512/J", partName: "FILTR COMB",  quantity: 1,  dealership: "Original Veiculos Ltda", city: "Caxias Do Sul" },
          { partNumber: "G/052739/Q9",  partName: "GRAXA",        quantity: 1,  dealership: "Original Veiculos Ltda", city: "Caxias Do Sul" },
          { partNumber: "G/052823/Q9",  partName: "LUBRIFICAN",   quantity: 42, dealership: "Original Veiculos Ltda", city: "Caxias Do Sul" },
          { partNumber: "JZV/820367/",  partName: "ELEM FILTR",  quantity: 1,  dealership: "Original Veiculos Ltda", city: "Caxias Do Sul" },
          { partNumber: "WHT/007791/H", partName: "ANEL",         quantity: 1,  dealership: "Original Veiculos Ltda", city: "Caxias Do Sul" },
        ],
      },
      { revIndex: 4, label: "3ª REV", km: null, parts: [] },
    ],
  },
  {
    chassis: "9539J8TH5TR201537",
    model: "28.480 6X2 HD 5.000 480C",
    modelCode: "TH5PJG",
    maintenanceContract: "X7641G",
    contractStatus: "A",
    lastRevisionDate: "12/03/2026",
    revisions: [
      {
        revIndex: 2,
        label: "1ª REV",
        km: 23927,
        dnSg: "4789 - 56041",
        repairDate: "21/11/2025",
        parts: [
          { partNumber: "2V3/127177/B", partName: "ELEM FILTR",  quantity: 1, dealership: "Transrio Cam. Ônib. Máq. e Motores Ltda.", city: "Caçapava" },
          { partNumber: "2V5/201512/J", partName: "FILTR COMB",  quantity: 1, dealership: "Transrio Cam. Ônib. Máq. e Motores Ltda.", city: "Caçapava" },
        ],
      },
      {
        revIndex: 3,
        label: "2ª REV",
        km: 51826,
        dnSg: "4880 - 43644",
        repairDate: "12/03/2026",
        parts: [
          { partNumber: "07W/115561/E", partName: "ELEM FILTR",  quantity: 1,  dealership: "Movel - Motores E Veículos Ltda", city: "Vitoria Da Conquista" },
          { partNumber: "2V3/127177/B", partName: "ELEM FILTR",  quantity: 1,  dealership: "Movel - Motores E Veículos Ltda", city: "Vitoria Da Conquista" },
          { partNumber: "2V3/129620/D", partName: "ELEMENTO",    quantity: 1,  dealership: "Movel - Motores E Veículos Ltda", city: "Vitoria Da Conquista" },
          { partNumber: "2V3/129620/E", partName: "ELEMENTO",    quantity: 1,  dealership: "Movel - Motores E Veículos Ltda", city: "Vitoria Da Conquista" },
          { partNumber: "2V5/201512/J", partName: "FILTR COMB",  quantity: 1,  dealership: "Movel - Motores E Veículos Ltda", city: "Vitoria Da Conquista" },
          { partNumber: "G/052168/Q9",  partName: "OLEO MOTOR",  quantity: 42, dealership: "Movel - Motores E Veículos Ltda", city: "Vitoria Da Conquista" },
          { partNumber: "G/052739/Q9",  partName: "GRAXA",        quantity: 2,  dealership: "Movel - Motores E Veículos Ltda", city: "Vitoria Da Conquista" },
          { partNumber: "JZV/820367/",  partName: "ELEM FILTR",  quantity: 1,  dealership: "Movel - Motores E Veículos Ltda", city: "Vitoria Da Conquista" },
        ],
      },
      { revIndex: 4, label: "3ª REV", km: null, parts: [] },
    ],
  },
  {
    chassis: "9539J8TH5TR201540",
    model: "28.480 6X2 HD 5.000 480C",
    modelCode: "TH5PJG",
    maintenanceContract: "X7641G",
    contractStatus: "A",
    lastRevisionDate: "10/04/2026",
    revisions: [
      {
        revIndex: 2,
        label: "1ª REV",
        km: 24952,
        dnSg: "4769 - 61973",
        repairDate: "16/10/2025",
        parts: [
          { partNumber: "2V3/127177/B", partName: "ELEM FILTR",  quantity: 1, dealership: "Transrio Cam, Onib, Maq E Motores Ltda", city: "São Leopoldo" },
          { partNumber: "2V5/201512/J", partName: "FILTR COMB",  quantity: 1, dealership: "Transrio Cam, Onib, Maq E Motores Ltda", city: "São Leopoldo" },
          { partNumber: "G/052739/Q9",  partName: "GRAXA",        quantity: 1, dealership: "Transrio Cam, Onib, Maq E Motores Ltda", city: "São Leopoldo" },
        ],
      },
      {
        revIndex: 3,
        label: "2ª REV",
        km: 47292,
        dnSg: "4778 - 52182",
        repairDate: "21/01/2026",
        parts: [
          { partNumber: "07W/115561/E", partName: "ELEM FILTR",  quantity: 1,  dealership: "Servopa Caminhões Ltda", city: "Curitiba" },
          { partNumber: "2V3/127177/B", partName: "ELEM FILTR",  quantity: 1,  dealership: "Servopa Caminhões Ltda", city: "Curitiba" },
          { partNumber: "2V3/129620/D", partName: "ELEMENTO",    quantity: 1,  dealership: "Servopa Caminhões Ltda", city: "Curitiba" },
          { partNumber: "2V3/129620/E", partName: "ELEMENTO",    quantity: 1,  dealership: "Servopa Caminhões Ltda", city: "Curitiba" },
          { partNumber: "2V5/201512/J", partName: "FILTR COMB",  quantity: 1,  dealership: "Servopa Caminhões Ltda", city: "Curitiba" },
          { partNumber: "G/052168/Q9",  partName: "OLEO MOTOR",  quantity: 42, dealership: "Servopa Caminhões Ltda", city: "Curitiba" },
          { partNumber: "G/052739/Q9",  partName: "GRAXA",        quantity: 1,  dealership: "Servopa Caminhões Ltda", city: "Curitiba" },
          { partNumber: "JZV/820367/",  partName: "ELEM FILTR",  quantity: 1,  dealership: "Servopa Caminhões Ltda", city: "Curitiba" },
          { partNumber: "WHT/007791/H", partName: "ANEL",         quantity: 1,  dealership: "Servopa Caminhões Ltda", city: "Curitiba" },
        ],
      },
      {
        revIndex: 4,
        label: "3ª REV",
        km: 73832,
        dnSg: "4880 - 44150",
        repairDate: "10/04/2026",
        parts: [
          { partNumber: "2S2/957039/A", partName: "TACOGRAFO", quantity: 0, dealership: "Movel - Motores E Veículos Ltda", city: "Vitoria Da Conquista" },
        ],
      },
    ],
  },
  {
    chassis: "9539J8TH6TR201546",
    model: "28.480 6X2 HD 5.000 480C",
    modelCode: "TH5PJG",
    maintenanceContract: "X7641G",
    contractStatus: "A",
    lastRevisionDate: "27/03/2026",
    revisions: [
      {
        revIndex: 2,
        label: "1ª REV",
        km: 23668,
        dnSg: "4789 - 55748",
        repairDate: "07/11/2025",
        parts: [
          { partNumber: "2V3/127177/B", partName: "ELEM FILTR",  quantity: 1, dealership: "Transrio Cam. Ônib. Máq. e Motores Ltda.", city: "Caçapava" },
          { partNumber: "2V5/201512/J", partName: "FILTR COMB",  quantity: 1, dealership: "Transrio Cam. Ônib. Máq. e Motores Ltda.", city: "Caçapava" },
        ],
      },
      {
        revIndex: 3,
        label: "2ª REV",
        km: 50623,
        dnSg: "4896 - 732",
        repairDate: "26/01/2026",
        parts: [
          { partNumber: "07W/115561/E", partName: "ELEM FILTR",  quantity: 1,  dealership: "Comercio De Automoveis Tubarao Ltda", city: "Icara" },
          { partNumber: "2V3/127177/B", partName: "ELEM FILTR",  quantity: 1,  dealership: "Comercio De Automoveis Tubarao Ltda", city: "Icara" },
          { partNumber: "2V3/129620/D", partName: "ELEMENTO",    quantity: 1,  dealership: "Comercio De Automoveis Tubarao Ltda", city: "Icara" },
          { partNumber: "2V3/129620/E", partName: "ELEMENTO",    quantity: 1,  dealership: "Comercio De Automoveis Tubarao Ltda", city: "Icara" },
          { partNumber: "2V5/201512/J", partName: "FILTR COMB",  quantity: 1,  dealership: "Comercio De Automoveis Tubarao Ltda", city: "Icara" },
          { partNumber: "G/052168/Q9",  partName: "OLEO MOTOR",  quantity: 42, dealership: "Comercio De Automoveis Tubarao Ltda", city: "Icara" },
          { partNumber: "JZV/820367/",  partName: "ELEM FILTR",  quantity: 1,  dealership: "Comercio De Automoveis Tubarao Ltda", city: "Icara" },
        ],
      },
      {
        revIndex: 4,
        label: "3ª REV",
        km: 75010,
        dnSg: "4884 - 58724",
        repairDate: "27/03/2026",
        parts: [
          { partNumber: "2S2/957039/A", partName: "TACOGRAFO", quantity: 0, dealership: "Transvel - Transportes E Veiculos Ltda", city: "Lobato" },
        ],
      },
    ],
  },
  {
    chassis: "9539J8TH7TR201538",
    model: "28.480 6X2 HD 5.000 480C",
    modelCode: "TH5PJG",
    maintenanceContract: "X7641G",
    contractStatus: "A",
    lastRevisionDate: "30/03/2026",
    revisions: [
      {
        revIndex: 2,
        label: "1ª REV",
        km: 23584,
        dnSg: "4763 - 60932",
        repairDate: "29/10/2025",
        parts: [
          { partNumber: "2V3/127177/B", partName: "ELEM FILTR",  quantity: 1, dealership: "Transrio Cam, Onib, Maq E Motores Ltda", city: "Rio De Janeiro" },
          { partNumber: "2V5/201512/J", partName: "FILTR COMB",  quantity: 1, dealership: "Transrio Cam, Onib, Maq E Motores Ltda", city: "Rio De Janeiro" },
          { partNumber: "G/052739/Q9",  partName: "GRAXA",        quantity: 1, dealership: "Transrio Cam, Onib, Maq E Motores Ltda", city: "Rio De Janeiro" },
        ],
      },
      {
        revIndex: 3,
        label: "2ª REV",
        km: 49785,
        dnSg: "4883 - 63528",
        repairDate: "20/01/2026",
        parts: [
          { partNumber: "07W/115561/E", partName: "ELEM FILTR",  quantity: 1,  dealership: "Transvel - Transportes E Veiculos Ltda", city: "Cascavel" },
          { partNumber: "2V3/127177/B", partName: "ELEM FILTR",  quantity: 1,  dealership: "Transvel - Transportes E Veiculos Ltda", city: "Cascavel" },
          { partNumber: "2V3/129620/D", partName: "ELEMENTO",    quantity: 1,  dealership: "Transvel - Transportes E Veiculos Ltda", city: "Cascavel" },
          { partNumber: "2V3/129620/E", partName: "ELEMENTO",    quantity: 1,  dealership: "Transvel - Transportes E Veiculos Ltda", city: "Cascavel" },
          { partNumber: "2V5/201512/J", partName: "FILTR COMB",  quantity: 1,  dealership: "Transvel - Transportes E Veiculos Ltda", city: "Cascavel" },
          { partNumber: "G/052168/Q9",  partName: "OLEO MOTOR",  quantity: 42, dealership: "Transvel - Transportes E Veiculos Ltda", city: "Cascavel" },
          { partNumber: "G/052739/Q9",  partName: "GRAXA",        quantity: 2,  dealership: "Transvel - Transportes E Veiculos Ltda", city: "Cascavel" },
          { partNumber: "JZV/820367/",  partName: "ELEM FILTR",  quantity: 1,  dealership: "Transvel - Transportes E Veiculos Ltda", city: "Cascavel" },
        ],
      },
      {
        revIndex: 4,
        label: "3ª REV",
        km: 74974,
        dnSg: "4883 - 65505 / 4883 - 65510",
        repairDate: "30/03/2026",
        parts: [
          { partNumber: "2S2/957039/A", partName: "TACOGRAFO",   quantity: 0, dealership: "Transvel - Transportes E Veiculos Ltda", city: "Cascavel" },
          { partNumber: "2V3/127177/B", partName: "ELEM FILTR",  quantity: 1, dealership: "Transvel - Transportes E Veiculos Ltda", city: "Cascavel" },
          { partNumber: "2V5/201512/J", partName: "FILTR COMB",  quantity: 1, dealership: "Transvel - Transportes E Veiculos Ltda", city: "Cascavel" },
          { partNumber: "G/052739/Q9",  partName: "GRAXA",        quantity: 1, dealership: "Transvel - Transportes E Veiculos Ltda", city: "Cascavel" },
        ],
      },
    ],
  },
  {
    chassis: "9539J8TH7TR201541",
    model: "28.480 6X2 HD 5.000 480C",
    modelCode: "TH5PJG",
    maintenanceContract: "X7641G",
    contractStatus: "A",
    lastRevisionDate: "12/03/2026",
    revisions: [
      {
        revIndex: 2,
        label: "1ª REV",
        km: 25331,
        dnSg: "4972 - 37258",
        repairDate: "11/11/2025",
        parts: [
          { partNumber: "2V3/127177/B", partName: "ELEM FILTR",  quantity: 1, dealership: "Mondial Veículos Ltda.", city: "Lajeado" },
          { partNumber: "2V5/201512/J", partName: "FILTR COMB",  quantity: 1, dealership: "Mondial Veículos Ltda.", city: "Lajeado" },
          { partNumber: "G/052168/Q9",  partName: "OLEO MOTOR",  quantity: 4, dealership: "Mondial Veículos Ltda.", city: "Lajeado" },
          { partNumber: "G/052739/Q9",  partName: "GRAXA",        quantity: 1, dealership: "Mondial Veículos Ltda.", city: "Lajeado" },
        ],
      },
      {
        revIndex: 3,
        label: "2ª REV",
        km: 50000,
        dnSg: "4797 - 32911",
        repairDate: "12/03/2026",
        parts: [
          { partNumber: "07W/115561/E", partName: "ELEM FILTR",  quantity: 1,  dealership: "Sulpasso Comércio de Caminhões Ltda.", city: "Passo Fundo" },
          { partNumber: "2V3/127177/B", partName: "ELEM FILTR",  quantity: 1,  dealership: "Sulpasso Comércio de Caminhões Ltda.", city: "Passo Fundo" },
          { partNumber: "2V3/129620/D", partName: "ELEMENTO",    quantity: 1,  dealership: "Sulpasso Comércio de Caminhões Ltda.", city: "Passo Fundo" },
          { partNumber: "2V3/129620/E", partName: "ELEMENTO",    quantity: 1,  dealership: "Sulpasso Comércio de Caminhões Ltda.", city: "Passo Fundo" },
          { partNumber: "2V5/201512/J", partName: "FILTR COMB",  quantity: 1,  dealership: "Sulpasso Comércio de Caminhões Ltda.", city: "Passo Fundo" },
          { partNumber: "G/052168/Q9",  partName: "OLEO MOTOR",  quantity: 42, dealership: "Sulpasso Comércio de Caminhões Ltda.", city: "Passo Fundo" },
          { partNumber: "G/052739/Q9",  partName: "GRAXA",        quantity: 1,  dealership: "Sulpasso Comércio de Caminhões Ltda.", city: "Passo Fundo" },
          { partNumber: "JZV/820367/",  partName: "ELEM FILTR",  quantity: 1,  dealership: "Sulpasso Comércio de Caminhões Ltda.", city: "Passo Fundo" },
        ],
      },
      { revIndex: 4, label: "3ª REV", km: null, parts: [] },
    ],
  },
  {
    chassis: "9539J8TH9TR201542",
    model: "28.480 6X2 HD 5.000 480C",
    modelCode: "TH5PJG",
    maintenanceContract: null,
    contractStatus: null,
    lastRevisionDate: "04/12/2025",
    revisions: [
      { revIndex: 2, label: "1ª REV", km: 50038, parts: [] },
      { revIndex: 3, label: "2ª REV", km: null,  parts: [] },
      { revIndex: 4, label: "3ª REV", km: null,  parts: [] },
    ],
  },
];

export function getChassisData(chassis: string): ChassisData | undefined {
  return CHASSIS_REVIEW_DATA.find(d => d.chassis === chassis);
}

export function getRevisionByIndex(chassis: string, revIndex: number): ChassisRevision | undefined {
  return getChassisData(chassis)?.revisions.find(r => r.revIndex === revIndex);
}
